// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","borderGrey":"#d5dfdf","errorRed":"#ff2a2a","caption":"_1dJD2pSCq2-UhXWE_3mRfd","body":"_2lYHSCAcM6vA2s-47YYZeS","container":"_1_pP8msMyQPNvhmYkz0FtB","input":"_25uxrdy4oZwaOMj748LqUF _2lYHSCAcM6vA2s-47YYZeS"};


//////////////////
// WEBPACK FOOTER
// ./src/common/installation-form/date-picker-input/DatePickerInput.css
// module id = 830
// module chunks = 0